var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"9","height":"16","viewBox":"0 0 9 16","fill":"none"}},[_c('path',{attrs:{"stroke":"#fff","d":"M8.354 15.646l-8-8M.354 8.354l8-8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }